module.exports = "<h1>Manage Admins</h1>\n<search-bar (filter-key)=filter($event) ></search-bar>\n<ul class=\"list-group\">\n  <li class=\"list-group-item list-group-action\" *ngFor=\"let user of filteredUser\" >\n    <button [ngClass]=\"{\n      'btn-danger':user.isAdmin,\n      'btn-warning':!user.isAdmin\n    }\" class=\"btn btn-sm\" (click)=\"toggleAdmin(user)\" >{{(!user.isAdmin) ? 'Make Admin':'Remove Admin'}}</button>\n    {{user.name}}\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/admin/manage-admins/manage-admins.component.html
// module id = ../../../../../src/app/admin/manage-admins/manage-admins.component.html
// module chunks = main